import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import PropTypes from 'prop-types'

// Components
import NREOverview from '../../nreoverview/NREOverview'
import ExhibitionElement from './exhibitionelement/ExhibitionElement'
import ExhibitionDetails from './exhibitiondetails/ExhibitionDetails'


class Exhibition extends Component {

    static propTypes = {
        exhibitions: PropTypes.array.isRequired
    }

    render() {
        return (
            <Switch>
                <Route exact path='/exhibitions' render={() =>
                    <NREOverview>
                        {this.props.exhibitions.map(exhibitionItem => {
                            return (
                                <ExhibitionElement key={exhibitionItem.url} exhibition={exhibitionItem} />
                            )
                        })}
                    </NREOverview>} />
                <Route path='/exhibitions/:string' component={ExhibitionDetails} />
            </Switch>
        )
    }
}

export default Exhibition;





// WEBPACK FOOTER //
// ./src/components/main/exhibition/Exhibition.js